import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import insightService, { InsightItem } from '@/services/insight.service';
import { Mutations } from '@/store';
import { markRaw, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import LearningItemForm from '../learning/LearningItemForm.vue';
import EventItemForm from '../events/EventItemForm.vue';
import StoryForm from '../stories/StoryForm.vue';
import storiesService from '@/services/stories.service';
import { Story } from '@/models/story.model';
import ContentItemForm from './ContentItemForm.vue';
import { TYPE_INITIATIVE } from '@/util/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryInsightList',
  setup(__props) {

const items = ref<InsightItem[]>([]);
const store = useStore();

onMounted(async () => {
  const result = await insightService.getListWithoutCategories();

  items.value = [...result];
});

async function editStory(s: Story) {
  const story = await storiesService.get(s.id);
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(StoryForm),
    data: story.data,
  });
}

function editItem(_: PointerEvent, { item }: { item: InsightItem }) {
  switch (item.type) {
    case 'Initiative':
      store.commit(Mutations.ShowDrawer, {
        component: markRaw(ContentItemForm),
        data: {
          type: TYPE_INITIATIVE,
          contentItem: item.item,
        },
      });
      break;
    case 'Event Item':
      store.commit(Mutations.ShowDrawer, {
        component: markRaw(EventItemForm),
        data: item.item,
      });
      break;
    case 'Learning Item':
      store.commit(Mutations.ShowDrawer, {
        component: markRaw(LearningItemForm),
        data: item.item,
      });
      break;
    case 'Quiz':
      editStory(item.item as Story);
      break;
  }
}

const headers = [
  { title: 'ID', key: 'item.id', width: '5%' },
  { title: 'Type', key: 'type', width: '10%' },
  { title: 'Title', key: 'item.title', width: '35%' },
  { title: 'Category', key: 'item.mainCategory.title', width: '25%' },
  { title: 'Problem', key: 'message', width: '25%' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Items with missing categories or main category", -1)),
      _createVNode(_component_v_data_table, {
        headers: headers,
        items: items.value,
        "onClick:row": editItem
      }, null, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})